/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Share_Saveandcontinue3Inputs */

const en_coinvestments_share_saveandcontinue3 = /** @type {(inputs: Coinvestments_Share_Saveandcontinue3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save and continue`)
};

/**
* | output |
* | --- |
* | "Save and continue" |
*
* @param {Coinvestments_Share_Saveandcontinue3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_share_saveandcontinue3 = /** @type {((inputs?: Coinvestments_Share_Saveandcontinue3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Share_Saveandcontinue3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_share_saveandcontinue3(inputs)
});
export { coinvestments_share_saveandcontinue3 as "coInvestments_share_saveAndContinue" }